import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

export default function Edit() {
    const navigate = useNavigate();

    const { ID } = useParams();
    const [E_ID, setE_ID] = useState("");
    const [InTime, setInTime] = useState("");
    const [OutTime, setOutTime] = useState("");

    const [validationError, setValidationError] = useState({});

    useEffect(() => {
        fetchPermanentLog();
    }, []);

    const fetchPermanentLog = async () => {
        await axios
            .get(
                `${process.env.REACT_APP_API}/permanent_log/APILimited/${ID}`
            )
            .then(({ data }) => {
                const { E_ID } = data[0];
                const { InTime } = data[0];
                const { OutTime } = data[0];

                setE_ID(E_ID);
                setInTime(InTime);
                setOutTime(OutTime);
            })
            .catch(({ response: { data } }) => {
                Swal.fire({
                    text: data.message,
                    icon: "error",
                });
            });
    };

    const updatePermanentLog = async (e) => {
        e.preventDefault();

        await axios
            .post(
                `${process.env.REACT_APP_API}/permanent_log/APILimited/${ID}`,
                {
                    InTime: InTime,
                    OutTime: OutTime,
                }
            )
            .then(({ data }) => {
                Swal.fire({
                    icon: "success",
                    timer: 1500,
                    text: data.message,
                });
                navigate("/permanentlog");
            })
            .catch(({ response }) => {
                if (response.status === 422) {
                    setValidationError(response.data.errors);
                } else {
                    Swal.fire({
                        text: response.data.message,
                        icon: "error",
                    });
                }
            });
    };

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-12 col-sm-12 col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Update PermanentLog</h4>
                            <hr />
                            <div className="form-wrapper">
                                {Object.keys(validationError).length > 0 && (
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="alert alert-danger">
                                                <ul className="mb-0">
                                                    {Object.entries(
                                                        validationError
                                                    ).map(([key, value]) => (
                                                        <li key={key}>
                                                            {value}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <Form  onSubmit={updatePermanentLog}>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>
                                                Employee ID
                                                </Form.Label>

                                                <Form.Control
                                                    type="text" disabled
                                                    required
                                                    value={E_ID}
                                                    onChange={(event) => {
                                                        setE_ID(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>
                                                InTime
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={InTime}
                                                    onChange={(event) => {
                                                        setInTime(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId="Name">
                                                <Form.Label>
                                                OutTime
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    value={OutTime}
                                                    onChange={(event) => {
                                                        setOutTime(
                                                            event.target.value
                                                        );
                                                    }}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group as={Row} className="mb-3 mt-3">
                                        <Col sm={{ span: 2, offset: 20 }}>
                                            <Button
                                                variant="secondary"
                                                type="submit"
                                            >
                                                <i class="fa fa-save"></i>  Update
                                            </Button>
                                        </Col>
                                    </Form.Group>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
